import { render, staticRenderFns } from "./deleteFeeConfig.vue?vue&type=template&id=2cdaaf05&scoped=true"
import script from "./deleteFeeConfig.vue?vue&type=script&lang=js"
export * from "./deleteFeeConfig.vue?vue&type=script&lang=js"
import style0 from "./deleteFeeConfig.vue?vue&type=style&index=0&id=2cdaaf05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdaaf05",
  null
  
)

export default component.exports